export enum ServerType {
    ArcGISMapServer = 0,
    ArcGISFeatureServer = 1,
    ArcGISImageServer = 2,
    ArcGISOnline = 3,
    OGCWMS = 4,
    OGCWMTS = 5,
    OGCWFS = 6,
    TileServer = 7
}